import { render, staticRenderFns } from "./CustomersSourceChart.vue?vue&type=template&id=7b1b1f89&scoped=true&"
import script from "./CustomersSourceChart.vue?vue&type=script&lang=js&"
export * from "./CustomersSourceChart.vue?vue&type=script&lang=js&"
import style0 from "./CustomersSourceChart.vue?vue&type=style&index=0&id=7b1b1f89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1b1f89",
  null
  
)

export default component.exports